import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MerlineServiceService {

  private baseUrl = 'https://aiprocure.elitetraveltech.in';

  constructor(
    private http: HttpClient
  ) { }

  // Login -> Session Generate
  createSession(payload: any): Observable<any> {

    return this.http.post(
      `${this.baseUrl}/mcp/login`,
      payload
    );

  }

  // Chat API
  sendMessage(payload: any): Observable<any> {

    return this.http.post(
      `${this.baseUrl}/mcp/chat`,
      payload
    );

  }

  // Logout Session
  logoutSession(sessionId: string): Observable<any> {

    return this.http.post(
      `${this.baseUrl}/mcp/logout/${sessionId}`,
      {}
    );

  }

  // Upload Document for Parsing
  uploadDocument(formData: FormData): Observable<any> {
    return this.http.post(
      `${environment.serverUrl}/api/v1/ai-intake/upload`,
      formData
    );
  }

}